export default __webpack_public_path__ + "static/media/cancel.cebfd72e.svg";